import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { RescueEventType } from '../rescue.event.type';
import { EventTypes } from '../../../../shared/EventTypes';
import { InvestmentsService } from '../../investments.service';
import { ActivatedRoute } from '@angular/router';
import { Investment } from '../../investments-extract/models/investment';
import { ListItem } from '../../../../shared/list-confirmation/model/list-item';
import { FormatPricePipe } from '../../../../shared/format-price.pipe';
import { Rescue } from '../../models/rescue';
import * as moment from 'moment';
import { AutenticationService } from '../../../../autentication/autentication.service';
import { Auth } from '../../../../autentication/Auth';

@Component({
	selector: 'app-rescue-application',
	templateUrl: './rescue-application.component.html',
	styleUrls: ['./rescue-application.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RescueApplicationComponent implements OnInit, OnDestroy {

	@Input() submited: boolean;
	@Input() investmentId: number;
	@Input() rescueData: Rescue;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private noAuthorization = false;

	form: FormGroup;
	signatureForm: FormGroup;
	view = '[data-component="rescue-application"]';
	active = false;
	investment: Investment = new Investment();
	sendConfirmedRescue = false;

	constructor(private route: ActivatedRoute,
		private autenticationService: AutenticationService,
		private formBuilder: FormBuilder,
		private investmentService: InvestmentsService) {
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00' || $('.currency-field').val() === 0) {
			$('.currency-field').val('');
		}
	}

	ngOnInit() {
		this.noAuthorization = Auth.getInstance().getUser().rule !== 'TRANSACIONAR';

		this.form = this.formBuilder.group({
			rescueType: ['total', Validators.required],
			value: [null]
		});

		this.showStepButtons.emit(false);

		AppEventDispatcher.listen(RescueEventType.SEND.RESCUE_SEND_RESULT, () => {
			this.send();
		});

		this.setForm.emit(this.form);
		this.show();
		this.active = true;
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RescueEventType.SEND.RESCUE_SEND_RESULT);
	}

	getRouteInvestmentId(data) {

		this.preload(true);

		this.investmentService.getInvestment(data.id).subscribe( investment => {
			this.investment = investment;
			this.preload(false);

			TweenMax.delayedCall(.5, () => {
				const containerHeight = this.getStepHeight();
				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			});

		}, error => {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: error.error.Mensagem});
		});

	}

	onSetSignatureForm(form: FormGroup) {
		this.signatureForm = form;

		if (this.sendConfirmedRescue) {

			if (this.noAuthorization) {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: 'Apenas clientes com perfil Autorizador podem realizar essa transação'});
				return;
			}

			this.send();
		}
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
					this.route.params.subscribe(data => {
						this.getRouteInvestmentId(data);
					});

				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});
				$('.currency-field').val('');

				clearInterval(interval);
			}

		}, 10);
		this.verifyZero();
	}

	hide() {
		this.showStepButtons.emit(true);

		this.investmentService.investment = null;
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(RescueEventType.STEPS.RESCUE_RESULT, { show: true });

			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	checkRescueTypeOption(type) {

		let containerHeight = this.getStepHeight();

		if (type !== 'total') {
			containerHeight  = this.getStepHeight() + 160;
			this.form.controls.value.setValidators(Validators.required);
			this.form.controls.value.updateValueAndValidity();
			$('.currency-field').val('');

		} else {
			containerHeight  = this.getStepHeight() - 160;
			this.form.controls.value.clearValidators();
			this.form.controls.value.updateValueAndValidity();
			this.form.controls.value.setValue('');
		}

		TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
	}

	addAuthToken() {
		Auth.passToken = this.signatureForm.value.token ? this.signatureForm.value.token : '';
		Auth.assinaturaEletronica = this.signatureForm.value.eletronicSignature ? this.signatureForm.value.eletronicSignature : '';
	}

	send() {
		if (this.noAuthorization) {
			this.preload(false);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: 'Apenas clientes com perfil Autorizador podem realizar essa transação'});
			return;
		}

		this.submited = true;

		if (this.signatureForm.valid) {

			this.preload(true);
			this.submited = false;

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.addAuthToken();

			this.autenticationService.sendDigitalSignature(this.signatureForm.value.eletronicSignature).subscribe(d => {

				this.submited = false;
				this.preload(true);

				this.investmentService.doRescue(this.investmentId, this.form.controls.value.value).subscribe( (data: Rescue) => {
					this.preload(false);

					this.rescueData.mainValue = data.mainValue;
					this.rescueData.yeldValue = data.yeldValue;
					this.rescueData.tax = data.tax;
					this.rescueData.grossRepurchaseAmount = data.grossRepurchaseAmount;
					this.rescueData.repurchaseAmount = data.repurchaseAmount;
					this.rescueData.message = data.message;
					this.rescueData.success = data.success;

					const FP = new FormatPricePipe();
					this.rescueData.resumeList = [];
					this.rescueData.resumeList.push(new ListItem('Título:', this.investment.description));
					this.rescueData.resumeList.push(new ListItem('Resgatado Bruto:', data.grossRepurchaseAmount.toString(), 'cls_mask'));
					this.rescueData.resumeList.push(new ListItem('Resgatado Líquido:', data.repurchaseAmount.toString(), 'cls_mask'));
					this.rescueData.resumeList.push(new ListItem('Rendimento:', data.yeldValue.toString(), 'cls_mask'));
					this.rescueData.resumeList.push(new ListItem('Impostos:', data.tax.toString(), 'cls_mask'));
					this.rescueData.resumeList.push(new ListItem('Data da operação:', moment().format('DD/MM/YYYY')));

					this.hide();

				},
				error => {

					this.hide();
					this.rescueData.message = error.error.messages.join(`\n`);
					this.rescueData.success = error.error.status === "SUCCESS";
					this.preload(false);

				});
			}, error => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(RescueEventType.ERROR, { step: RescueEventType.STEPS.RESCUE_RESULT });
			});

		}

	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="rescue"] .content', show: active, delay: delay});
	}

	getMessageConfirmedRescue(message: boolean) {
		this.sendConfirmedRescue = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/rescue/rescue-application/rescue-application.component.ts